import {StorageKey} from "../../storage";
import {createReactiveLocalStoreByKey} from "../../utils/create-reactive-local-store";
import {defaultRecipeView, type RecipeView} from "./recipe-order";

// one view for all groups, kept per device
const [useStoredView, setStoredView, {getValue}] = createReactiveLocalStoreByKey<
  "all",
  StorageKey.RECIPE_VIEW
>({keyToStorageKey: () => StorageKey.RECIPE_VIEW});

export const useRecipeView = (): RecipeView => useStoredView("all") ?? defaultRecipeView;

export const updateRecipeView = (patch: Partial<RecipeView>) =>
  setStoredView("all", {...defaultRecipeView, ...getValue("all"), ...patch});
